export const progressbar = {
  colorScheme: {
    light: {
      height: '8px',
      background: '#b7dbf363',
      value: {
        background: '#48ADF1',
      },
    },
    dark: {
      height: '8px',
      background: '#b7dbf363',
      value: {
        background: '#48ADF1',
      },
    },
  },
};
